import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import loading from '../images/loading.gif'

class OverlayLoader extends Component {
    render() {
        return (
            <div>
                <Modal                    
                    aria-labelledby="contained-modal-title-vcenter"
                    centered 
                    show={this.props.show}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header hidden={true}>
                        <Modal.Title className="ms-auto">
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <img src={loading} className="rounded mx-auto d-block" alt="" />
                        <p  className="text-center">{this.props.body}</p>
                    </Modal.Body>
                </Modal>
            </div>
        )
    };
}

export default OverlayLoader;